import { Button } from '@/components/atoms/button';

interface DataTableDrawerApplyFooterProps {
  onApply: () => void;
}

export function DataTableDrawerApplyFooter({ onApply }: DataTableDrawerApplyFooterProps) {
  return (
    <div className="border-t px-5 py-4">
      <Button className="w-full" onClick={onApply}>
        Apply
      </Button>
    </div>
  );
}
